<ng-container *ngIf="partner$ | async as partner">
  <h5 class="eb-contact-card__header">{{ 'contactCard.header' | cxTranslate }}</h5>
  <h3 class="eb-contact-card__name">{{ partner.name }}</h3>
  <p class="eb-contact-card__hint">
    {{ 'contactCard.hint.for' + partner.partnerFunction | cxTranslate }}
  </p>
  <a class="eb-contact-card__phone" [href]="'tel:' + partner.phoneNumber">
    {{ 'contactCard.phoneNumber' | cxTranslate: { phoneNumber: partner.phoneNumber } }}
  </a>
  <a class="eb-contact-card__email" [href]="'mailto:' + partner.email">
    {{ 'contactCard.email' | cxTranslate: { email: partner.email } }}
  </a>
</ng-container>
